import React, { useState } from "react";
import { IProps } from "./types";
import cls from "./dropList.module.scss"

const DropList: React.FC<IProps> = ({ 
        item: { 
            convertedSettings: { styles, parentStyles },
            dropListSettings: { fontSize } = {},
            dropList,
            customClassNames
        } 
    }) => {
    const [selected, setSelected] = useState<{ content: string; isPDF: boolean; id: number } | null>(null)

    const containsPDFLink = (htmlString: string) => {
        if (typeof window === 'undefined') return false;
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const links = doc.querySelectorAll('a');
        return Array.from(links).some(link => link.href.endsWith('.pdf'));
    };

    return (
        <div style={parentStyles}>
            <ul style={styles} className={`${cls.dropList} ${customClassNames}`}>
                {dropList.map(({ title, content }, i) => {
                    return (
                        <li className={cls.dropListItem} key={i}>
                            <span
                                className={`${cls.dropListItemTitle} ${selected?.id === i && cls.selectedTitle}`}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    const isPDF = containsPDFLink(content);
                                    setSelected(prev => {
                                        return (prev === null || prev?.id !== i) ? { content, isPDF, id: i } : null
                                    })
                                }}
                                style={{fontSize: `${fontSize}px`}}
                            >
                                {title}
                            </span>
                        </li>
                    )
                }
                )}
                {dropList.map(elem => {
                    return (
                        <div className={cls.dropListItemDecr} style={{ display: "none" }}>
                            <div className={cls.content} dangerouslySetInnerHTML={{__html: elem.content}}/>
                        </div>
                    )
                })}
                {selected && (
                    <div className={cls.dropListItemDecr} >
                        <div className={cls.content} dangerouslySetInnerHTML={{ __html: selected.content }} />
                    </div>
                )}
            </ul>
        </div>)
}

export default DropList